<template>
    <div class="ado-settings">
        <div class="ado-settings__header">
            <h5 class="ado-settings__header-title">Settings</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ado-admin-settings'
}
</script>

<style>
.ado-settings__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-settings__header-title {
    font-weight: 600;
    margin: 0;
}

.ado-settings__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 18px;
    font-weight: 700;
    min-height: 64px;
    padding: 16px 20px;
}

.ado-settings__title>i {
    color: #5d78ff;
    font-size: 1.25rem;
}
</style>